import SelectPlayerModal from './SelectPlayerModal';

export default SelectPlayerModal;
